export function getCurrentEpochDayByTimezone(timezone?: string): number {
  const tz = timezone ?? 'UTC';
  const now = new Date();

  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  const localDateStr = formatter.format(now);
  const localDate = new Date(`${localDateStr}T00:00:00Z`);

  return Math.floor(localDate.getTime() / (1000 * 60 * 60 * 24));
}
